module.exports = __webpack_public_path__ + "static/media/download-pdf.eb32002a.png";